<template>
  <v-data-table
    :headers="permissionHeaders"
    :items="permissions"
    :expanded.sync="expanded"
    :options.sync="options"
    :footer-props="{
      'items-per-page-options': [10, 20, 30, 40, 50, -1]
    }"
    item-key="name"
    dense
    show-expand
    class="elevation-1"
  >
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        <v-chip
          v-for="(user, j) in item.users"
          class="ma-2"
          small
          :key="j"
        >
          {{ user.user_name }}
        </v-chip>
      </td>
    </template>
    <template v-slot:item.count="{ item }">
      {{ item.users.length }}
    </template>
    <template v-slot:item.actions="{ item }">
      <!-- <v-icon
        small
        class="mr-2"
        @click="editPermissionLevel(item)"
      >
        mdi-pencil
      </v-icon> -->
    </template>
  </v-data-table>
</template>
<script>
  export default {
    name: 'UserPermissionLevels',
    props: {
      permissions: Array,
    },
    data () {
      return {
        expanded: [],
        permissionHeaders: [
          {
            text: 'Name',
            align: 'start',
            value: 'title'
          },
          {
            text: 'Description',
            value: 'description'
          },
          {
            text: 'Users',
            value: 'count'
          },
          // { value: 'actions', text: 'Actions', sortable: false },
          { text: '', value: 'data-table-expand' },
        ],
        options: {
          itemsPerPage: 20,
          sortBy: ['title'],
        },
      }
    },
    methods: {
      editPermissionLevel: function (permission) {
        return
      },
    }
  }
</script>